<template>
  <label class="checkbox" :class="{ disabled }">
    <!-- 실제 checkbox 가리기-->
    <input type="checkbox" :checked="modelValue" :disabled="disabled" @change="onChange" />

    <span class="checkbox-ui">
      <!-- <IconCheck v-if="modelValue" /> -->
      <IconCheck></IconCheck>
    </span>

    <p v-if="$slots.default">
      <slot />
    </p>
  </label>
</template>

<script setup lang="ts">
import IconCheck from '@/components/icons/IconCheck.vue';

defineProps<{
  modelValue: boolean;
  disabled?: boolean;
}>();

const emit = defineEmits<{
  (e: 'update:modelValue', value: boolean): void;
}>();

const onChange = (e: Event) => {
  const target = e.target as HTMLInputElement;
  emit('update:modelValue', target.checked);
};
</script>

<style scoped lang="scss">
.checkbox {
  display: inline-flex;
  align-items: flex-start;
  gap: 0.5rem;
  cursor: pointer;
  user-select: none;

  &.disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }

  /* 실제 checkbox 숨김 */
  input {
    display: none;
  }

  .checkbox-ui {
    position: relative;
    top: 0.25rem;
    width: 1.125rem;
    height: 1.125rem;
    background-color: $color-gray-50;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
    flex-shrink: 0;
    border-radius: 0.25rem;
    svg {
      color: #fff;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }

  input:checked + .checkbox-ui {
    background-color: var(--surface-primary);
    border-color: var(--surface-primary);
  }

  input:disabled + .checkbox-ui {
    background-color: var(--surface-gray);
    border-color: var(--border-default);
  }
}
</style>
